import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Proptypes from 'prop-types';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import { api as stockApi } from '../../store/domains/stock';
import { a11yProps, TabPanel } from '../TabPanel';

IccidHubDialog.propTypes = {
  open: Proptypes.bool,
  handleClose: Proptypes.func,
};

export default function IccidHubDialog({ open, handleClose }) {
  const { data: hubList, isLoading: hubListLoading } = stockApi.useGetHubList();
  const [fileUploadMutation, { isLoading }] = stockApi.usePostAssignStartPackHubWithFile();
  const [mutation, { isLoading: listLoading }] = stockApi.usePostAssignIccidHubWithList();

  const [selectValue, setSelectValue] = useState('');
  const [file, setFile] = useState();
  const [text, setText] = useState();
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function handleChangeText(event) {
    setText(event.target.value);
  }
  // const [postIccidHubMutation] = stockApi.usePostIccidHub();
  // const RangeSchema = Yup.object().shape({
  //   minId: Yup.string().required('Min range is required'),
  //   maxId: Yup.string().required('Max range is required'),
  //   hubId: Yup.string().required('Hub is required'),
  // });

  // const defaultValues = {
  //   minId: '',
  //   maxId: '',
  //   hubId: '',
  // };

  // const methods = useForm({
  //   resolver: yupResolver(RangeSchema),
  //   defaultValues,
  // });

  // const {
  //   handleSubmit,
  //   formState: { isSubmitting },
  // } = methods;

  // const onSubmit = (data) => {
  //   postIccidHubMutation(data)
  //     .unwrap()
  //     .finally(() => {
  //       handleClose();
  //     });
  // };
  function handleChangeForm(event) {
    setFile(event.target.files[0]);
  }
  const handleChangeSelect = (event) => {
    setSelectValue(event.target.value);
  };
  const onSubmit = () => {
    const form = new FormData();
    form.append('file', file);
    const data = {
      form,
      hubID: selectValue,
    };
    fileUploadMutation(data)
      .unwrap()
      .finally(() => {
        setSelectValue('');
        setFile('');
        handleClose();
      });
  };

  const onSubmitList = () => {
    const identifiers = text?.split('\n');
    const data = {
      body: { identifiers },
      hubID: selectValue,
    };

    mutation(data)
      .unwrap()
      .finally(() => {
        handleClose();
      });
  };
  if (hubListLoading || listLoading) {
    return <CircularProgress />;
  }
  return (
    <Dialog maxWidth="sm" open={open} onClose={handleClose} fullWidth>
      <DialogTitle>Assign</DialogTitle>
      <DialogContent>
        {/* <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={3} sx={{ my: 2 }}>
            <RHFTextField name="minId" label="Min range" />
          </Stack>{' '}
          <Stack spacing={3} sx={{ my: 2 }}>
            <RHFTextField name="maxId" label="Max range" />
          </Stack>
          <FormControl fullWidth>
            <InputLabel>Hub</InputLabel>
            <Controller
              control={methods.control}
              name="hubId"
              defaultValue=""
              render={({ field }) => (
                <Select label="Hub" {...field}>
                  {hubList?.map(({ hubId, title }) => (
                    <MenuItem key={hubId} value={hubId}>
                      {title}
                    </MenuItem>
                  ))}
                </Select>
              )}
            />
            <LoadingButton
              sx={{ my: 2 }}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              Submit
            </LoadingButton>
          </FormControl>
        </FormProvider> */}
        <FormControl fullWidth>
          <InputLabel id="hub-label">Hub</InputLabel>
          <Select labelId="hub-label" id="hub" label="Hub" value={selectValue} onChange={handleChangeSelect}>
            {hubList?.map(({ hubId, title }) => (
              <MenuItem key={hubId} value={hubId}>
                {title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            {/* <Tab label="Range" {...a11yProps(0)} /> */}
            <Tab label="File" {...a11yProps(0)} />
            <Tab label="Text" {...a11yProps(1)} />
            {/* <Tab label="Write" {...a11yProps(2)} /> */}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Box display="flex" alignItems="center">
            <Button
              sx={{
                marginTop: 3,
              }}
              variant="contained"
              component="label"
            >
              Upload File
              <input onChange={handleChangeForm} type="file" hidden />
            </Button>
            {file && (
              <Box display="flex" alignItems="center" marginLeft={4}>
                {file.name}
                <CheckCircleOutlineIcon sx={{ marginLeft: 1 }} color="success" />
              </Box>
            )}
          </Box>
          <LoadingButton
            loading={isLoading}
            disabled={isLoading || !file || !selectValue}
            onClick={onSubmit}
            sx={{ my: 2 }}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            Submit
          </LoadingButton>
        </TabPanel>{' '}
        <TabPanel value={value} index={1}>
          <Box display="flex" alignItems="center" marginTop={3}>
            <TextField
              fullWidth
              label="Write..."
              multiline
              rows={4}
              value={text}
              onChange={(e) => handleChangeText(e)}
            />
          </Box>

          <LoadingButton
            loading={isLoading}
            disabled={isLoading || !text || !selectValue}
            onClick={onSubmitList}
            sx={{ my: 2 }}
            fullWidth
            size="large"
            type="submit"
            variant="contained"
          >
            Submit
          </LoadingButton>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}
